import {isEmpty} from 'ramda';

import {BankAccountDomain} from '@dms/api/base';

import {Nullish} from 'shared/web';

import {ALL_BANK_ACCOUNT_DOMAINS} from '../constants/ALL_BANK_ACCOUNT_DOMAINS';
import type {BankAccountDomainSelectValue} from '../types/BankAccountDomainSelectValue';

/**
 * Maps a persisted domain assignment into the form selector value.
 * An empty/unset assignment is shown as the FE-only "All" option.
 */
export function toBankAccountDomainSelectValue(
  domains: BankAccountDomain[] | Nullish
): BankAccountDomainSelectValue[] {
  const assignedDomains = domains ?? [];

  return isEmpty(assignedDomains) ? [ALL_BANK_ACCOUNT_DOMAINS] : assignedDomains;
}
